


let mm = gsap.matchMedia();
CustomEase.create("primary-ease", "0.62, 0.05, 0.01, 0.99");
const lenis = new Lenis();
lenis.on("scroll", ScrollTrigger.update);
gsap.ticker.add((time) => {
    lenis.raf(time * 1000);
});
gsap.ticker.lagSmoothing(0);
$(".top-btn").on("click", function () {
    lenis.scrollTo(0);
});
$(".notice-close").on("click", function () {
    lenis.scrollTo(40);
});
let object = {
    value: 1,
};
let tl = gsap.timeline({ repeat: -1 });
tl.fromTo(
    ".marquee_track",
    {
        xPercent: 0,
    },
    {
        xPercent: -50,
        duration: 14,
        ease: "none",
    },
);
mm.add("(min-width: 992px)", () => {
    $(".workout-block").hover(
        function () {
            var workoutImg = $(this).find("img").attr("src"),
            workoutImgSrcset = $(this).find("img").attr("srcset"),
            workoutTitle = $(this).data("title");

            $(".workout-block").removeClass("active");
            $(this).addClass("active");
            $(".explore-img").attr("src", workoutImg);
            $(".explore-img").attr("srcset", workoutImgSrcset);
            $(".explore-title").html( workoutTitle );
        },
        function () { },
    );
    $(".features-list_item").each(function (index) {
        $(this).hover(
            function () {
                $(".features-list_item")
                    .eq(index)
                    .find(".features-number")
                    .addClass("active");
                $(".is-desktop .features-indicator").eq(index).addClass("active");
            },
            function () {
                $(".features-list_item")
                    .eq(index)
                    .find(".features-number")
                    .removeClass("active");
                $(".is-desktop .features-indicator").eq(index).removeClass("active");
            },
        );
    });
    $(".is-desktop .features-indicator").each(function (index) {
        $(this).hover(
            function () {
                $(".features-list_item")
                    .eq(index)
                    .find(".features-number")
                    .addClass("active");
                $(".is-desktop .features-indicator").eq(index).addClass("active");
            },
            function () {
                $(".features-list_item")
                    .eq(index)
                    .find(".features-number")
                    .removeClass("active");
                $(".is-desktop .features-indicator").eq(index).removeClass("active");
            },
        );
    });
});
//HOMEPAGE SLIDER
$(".swiper-component").each(function (index) {
    let totalSlides = $(this).find(".swiper-slide").length;
    let slideNext = $(this).find(".swiper-slide");
    $(".slide-total").text(totalSlides);
    const imageSwiper = new Swiper($(this).find(".swiper")[0], {
        // Optional parameters
        loop: true,
        effect: "fade",
        speed: 600,
        autoHeight: true,
        fadeEffect: {
            crossFade: true,
        },
        slidesPerView: 1,
        // Navigation arrows
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        // And if we need scrollbar
        scrollbar: {
            el: ".swiper-scrollbar",
        },
    });
    $(slideNext).on("click", function () {
        imageSwiper.slideNext();
    });
    imageSwiper.on("slideChange", function (e) {
        let slideNumber = e.realIndex + 1;
        $(".slide-number").text(slideNumber);
    });
});

//PRODUCT SLIDER

const buildSwiperSlider = slideID => {

    var prodSwiperThumb = new Swiper(`#thumbs-${slideID}`, {
        loop: true,
        spaceBetween: 10,
        slidesPerView: "auto",
        freeMode: true,
    });
    var prodSwiper = new Swiper(`#slider-${slideID}`, {
        loop: true,
        spaceBetween: 10,
        thumbs: {
          swiper: prodSwiperThumb,
        },
        pagination: {
            el: `#pagination-${slideID}`,
            clickable: true,
        },
    });
}
$('.productswiper').each(function(){
    let sliderIdentifier = $(this).data('id');
    buildSwiperSlider(sliderIdentifier);
});



//WORKOUTS SLIDER
const swiper = new Swiper(".swiper.ambassadors", {
    // Default parameters
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    effect: "fade",
    slidesPerView: 1,
    fadeEffect: {
        crossFade: true,
    },
    mousewheel: {
        forceToAxis: true,
    },
    navigation: {
        nextEl: ".swiper-button",
    },
    pagination: {
        el: ".swiper-bullet_wrapper",
        bulletClass: "amabassador-btn",
        bulletElement: "button",
        clickable: true,
        keyboard: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
    },
});
//DROPDOWN
$(".dropdown-item .dropdown-toggle").on("click", function (event) {
    event.stopPropagation();
    $(this).closest(".dropdown-item").toggleClass("is-active");
    $(".dropdown-item")
        .not($(this).closest(".dropdown-item"))
        .removeClass("is-active");
});
$(".footer-link").hover(
    function () {
        $(this).siblings(".footer-link").addClass("muted");
    },
    function () {
        $(this).siblings(".footer-link").removeClass("muted");
    },
);
$(".nav-trigger").each(function (index) {
    ScrollTrigger.create({
        trigger: $(this),
        start: "top top",
        end: "bottom top",
        onEnter: () => {
            $(".nav-component").addClass("scrolled");
        },
        onEnterBack: () => {
            $(".nav-component").removeClass("scrolled");
        },
        onLeaveBack: () => {
            $(".nav-component").removeClass("scrolled");
        },
    });
});
let splitText;
function runSplit() {
    splitText = new SplitType("[stagger-link]", {
        types: "words, chars",
    });
}
runSplit();
// ————— Update on window resize
let windowWidth = $(window).innerWidth();
window.addEventListener("resize", function () {
    if (windowWidth !== $(window).innerWidth()) {
        windowWidth = $(window).innerWidth();
        splitText.revert();
        runSplit();
    }
});
function homeLoad() {
    let pLoad = gsap.timeline({});
    pLoad.set(".page-main", {
        autoAlpha: 1,
    });
    pLoad.fromTo(
        ".landing-img_left img",
        {
            scale: 1.2,
            clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)",
        },
        {
            scale: 1,
            clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
            ease: "power3.out",
            duration: 1.4,
        },
    );
    pLoad.fromTo(
        ".landing-img_right img",
        { scale: 1.2, clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)" },
        {
            scale: 1,
            clipPath: "polygon(0% 0%, 110% 0%, 110% 100%, 0% 100%)",
            ease: "power3.out",
            duration: 2,
        },
        "<10%",
    );
    pLoad.from(
        ".hero-text",
        {
            yPercent: 100,
            ease: "circ.out",
            stagger: {
                each: 0.2,
                from: "start",
            },
            duration: 1.2,
        },
        "<30%",
    );
    pLoad.fromTo(
        "[nav-intro]",
        {
            yPercent: -200,
        },
        {
            yPercent: 0,
            ease: "power3.out",
            duration: 1,
        },
        "<30%",
    );
    pLoad.fromTo(
        "[intro-fade]",
        {
            opacity: 0,
        },
        {
            opacity: 1,
            ease: "power3.out",
            duration: 1,
        },
        "<",
    );
}
function pageLoad() {
    let pLoad = gsap.timeline({});
    pLoad.set(".page-main", {
        autoAlpha: 1,
    });
    pLoad.fromTo(
        ".landing-img_left img",
        {
            scale: 1.2,
            clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)",
        },
        {
            scale: 1,
            clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
            ease: "power3.out",
            duration: 1.4,
        },
    );
}
mm.add("(max-width: 991px)", () => {
    let currentIndex = 0;
    let itemCount = $(".is-mobile .features-indicator").length;
    let timeline;
    // Function to activate item by index
    function activateItem(index) {
        $(".features-list_item").removeClass("active");
        $(".is-mobile .features-indicator").removeClass("active");
        $(".features-list_item").eq(index).addClass("active");
        $(".is-mobile .features-indicator").eq(index).addClass("active");
    }
    // Function to create the GSAP timeline
    function createTimeline() {
        if (timeline) {
            timeline.kill();
        }
        timeline = gsap.timeline({ repeat: -1 });
        for (let i = 0; i < itemCount; i++) {
            timeline.to(
                {},
                {
                    duration: 1.5,
                    onComplete: () => activateItem((currentIndex + i) % itemCount),
                },
            );
        }
    }
    // Click event handler to activate item and reset timeline
    $(".is-mobile .features-indicator").each(function (index) {
        $(this).click(function () {
            currentIndex = index;
            activateItem(currentIndex);
            createTimeline();
        });
    });
    // Initial activation and timeline creation
    activateItem(currentIndex);
    createTimeline();
});
//MENU
$(".page-main").each(function () {
    let menuOpenBtn = $(this).find(".nav-menu_btn");
    let menuCloseBtn = $(this).find(".menu-close");
    let menuPopup = $(this).find(".menu-component");
    let menuBg = $(this).find(".menu-overlay");
    let menuLinks = $(this).find(".menu-link_wrap");
    let menuLinkItems = menuLinks.find(".menu-link");
    let menuTl = gsap.timeline({
        paused: true,
    });
    mm.add("(max-width: 991px)", () => {
        menuTl.set(menuPopup, { display: "block" });
        menuTl.fromTo(
            menuBg,
            {
                opacity: 0,
            },
            {
                opacity: 0.4,
                duration: 0.4,
                ease: "linear",
            },
        );
        menuTl.fromTo(
            ".is-mobile_grid",
            {
                xPercent: "100",
            },
            {
                xPercent: "0",
                duration: 1,
                ease: "primary-ease",
                clearProps: "all",
            },
            "<",
        );
    });
    mm.add("(min-width: 992px)", () => {
        menuTl.set(menuPopup, { display: "flex" });
        menuTl.fromTo(
            menuBg,
            {
                opacity: 0,
            },
            {
                opacity: 0.4,
                duration: 0.4,
                ease: "linear",
            },
        );
        menuTl.fromTo(
            "[menu-clip]",
            {
                clipPath: "polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)",
            },
            {
                clipPath: "polygon(100% 0%, 0% 0%, 0% 100%, 100% 100%)",
                duration: 1,
                stagger: 0.07,
                ease: "primary-ease",
                // clearProps: "all",
            },
            "<",
        );
    });
    menuTl.from(
        $(menuLinkItems).find(".menu-link_text"),
        {
            yPercent: 100,
            opacity: 0,
            duration: 1,
            ease: "power3.out",
            stagger: 0.05,
            clearProps: "all",
        },
        "<60%",
    );
    menuTl.from(
        ".menu-mid, .menu-btn",
        {
            opacity: 0,
            duration: 0.2,
            ease: "none",
            clearProps: "all",
        },
        "<",
    );
    function openMenu(open) {
        if (!menuTl.isActive()) {
            if (open) {
                menuTl.timeScale(1);
                menuTl.restart();
                lenis.stop();
            } else {
                menuTl.timeScale(1.5);
                menuTl.reverse();
                lenis.start();
            }
        }
    }
    menuOpenBtn.on("click", function () {
        openMenu(true);
    });
    menuCloseBtn.on("click", function () {
        openMenu(false);
    });
    menuBg.on("click", function () {
        openMenu(false);
    });
    $(document).on("keydown", function (e) {
        if (e.key === "Escape") {
            openMenu(false);
        }
    });
    //CART FUNCTIONALITY
    let cartOpenBtn = $(this).find(".nav-cart_btn");
    let cartCloseBtn = $(this).find(".cart-close_btn");
    let cartPopup = $(this).find(".cart-component");
    let cartBg = $(this).find(".cart-overlay");
    let cartTl = gsap.timeline({
        paused: true,
    });
    cartTl.set(cartPopup, { display: "block" });
    cartTl.fromTo(
        cartBg,
        {
            opacity: 0,
        },
        {
            opacity: 0.4,
            duration: 0.4,
            ease: "linear",
        },
    );
    cartTl.fromTo(
        "[cart-clip]",
        {
            clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)",
        },
        {
            clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
            duration: 0.6,
            stagger: 0.07,
            ease: "power3.inOut",
        },
        "<",
    );
    cartTl.from(
        $(".cart-heading"),
        {
            yPercent: 100,
            duration: 1,
            ease: "power3.out",
        },
        "<30%",
    );
    cartTl.fromTo(
        ".cart-img_component img",
        {
            scale: 1.2,
            clipPath: "polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)",
        },
        {
            scale: 1,
            clipPath: "polygon(100% 0%, 0% 0%, 0% 100%, 100% 100%)",
            duration: 1,
            stagger: 0.07,
            ease: "power3.out",
            // clearProps: "all",
        },
        "<",
    );
    scale: 1.2,
        cartTl.from(
            "[cart-fade]",
            {
                opacity: 0,
                duration: 0.4,
                ease: "none",
            },
            "<30%",
        );
    function openCart(open) {
        if (!cartTl.isActive()) {
            if (open) {
                cartTl.restart();
                lenis.stop();
            } else {
                cartTl.reverse();
                lenis.start();
            }
        }
    }
    cartOpenBtn.on("click", function () {
        openCart(true);
    });
    cartCloseBtn.on("click", function () {
        openCart(false);
    });
    $(".cart-popup_btn").on("click", function () {
        openCart(false);
    });
    cartBg.on("click", function () {
        openCart(false);
    });
    $(document).on("keydown", function (e) {
        if (e.key === "Escape") {
            openCart(false);
        }
    });





// product atc
    $(document).ready(function () {
        if($('.review-toggle').length > 0) {
            $('.review-toggle').on('click',function(e){
                e.preventDefault();
                $('.hidden-reviews').slideToggle(2000);
                $('.review-toggle .std-btn_text').html($('.review-toggle .std-btn_text').html() == 'See more reviews' ? 'See less reviews' : 'See more reviews');
            });
        }
        // BLOG FILTER
            let currentPage = 1;
            const postsPerPage = 1000;
          
            // Function to update the count next to each filter
            function updateFilterCounts() {
              $('.filter').each(function() {
                const category = $(this).data('category');
                const count = $('.blog-post[data-category*="' + category + '"]').length;
                $('.count[data-category="' + category + '"]').text("("+count+")");
              });
            }
          

            function containsAllWords(str, words) {
                return words.every(word => str.includes(word.toLowerCase()));
            }
            // Function to filter blog posts
            function filterPosts() {
              const selectedFilters = $('.filter:checked').map(function() {
                return $(this).data('category');
              }).get();

              if (selectedFilters.length === 0) {
                $('.blog-post').show();
              } else {
                $('.blog-post').hide();
                let filterLength = selectedFilters.length;

                // let filterSting = '';
                // selectedFilters.forEach(function(filter) {
                //   filterSting += filter+' ';
                // });
                // $('.blog-post[data-category*="' + filterSting + '"]').show();
                $('.blog-post').each(function(){
                    let $this = $(this),
                    category = $this.data('category'),
                    count = 0;

                    const result = containsAllWords(category, selectedFilters);
                    if(result == true) {
                        $this.show();
                    }
                    /*
                    if (category.split(' ').some(part => selectedFilters.includes(part))) {

                        count = count + 1;
                    }

                    if(count == filterLength) {
                        $this.show();
                    }
                    */
                });
              }
              updateFilterCounts();
            }
          
            // Initial filter count update
            updateFilterCounts();
          
            // Event listener for filter changes
            $('.filter').change(function() {
              filterPosts();
            });
          
            // Load more posts on button click
            $('#load-more').click(function() {
              currentPage++;
              const totalPosts = $('#total-posts').data('total');
              if (currentPage * postsPerPage < totalPosts) {
                $.ajax({
                  url: '/blogs/workout?page=' + currentPage,
                  type: 'GET',
                  success: function(data) {
                    const newPosts = $(data).find('.blog-post');
                    $('#blog-posts').append(newPosts);
                    filterPosts();
                  }
                });
              } else {
                $('#load-more').hide();
              }
            });

          
        // END BLOG FILTER




        function updateVariantAndAvailability(removeSlide) {
            const selectedColor = $('.colorSelect:checked').val();
            const selectedSize = $('.sizeSelect:checked').val();
            const selectedVariant = `${selectedSize} / ${selectedColor}`;
            $('.selected-color').text(selectedColor);
            // Update selected variant display
            $('.selected-product option').each(function(){
                let variant = $(this).data('variant');
                if(selectedVariant === variant) {
                    let price = $(this).data('price'),
                    availability = $(this).data('available'),
                    id = $(this).val(),
                    included = $(this).data('included-group');
                    $('.price-target').html(price);
                    if(availability == true) {
                        $('.atc-button-target').removeClass('disable-click');
                        $('.atc-button-target .std-btn_text').html('ADD TO BASKET');
                    } else {
                        $('.atc-button-target').addClass('disable-click');
                        $('.atc-button-target .std-btn_text').html('OUT OF STOCK');
                    }
                    $('.included-grid').hide();
                    $('.included-grid.'+included).show();
                    if($('.variant-gallery').length > 0){
                        $('.product-image-wrapper').removeClass('active-gallery');
                        $('.variant-gallery-'+id).addClass('active-gallery');
                       
                        if(removeSlide && !$('.product-section').hasClass('slide-removed')) {
                            $('.has-landing-image .swiper-slide').eq(0).remove();
                            // $('.has-landing-image').update();
                            $('.has-landing-image-thumb .swiper-slide').eq(0).remove();
                            // var landingThumb = new Swiper('.has-landing-image-thumb').update();
                            $('.product-section').addClass('slide-removed');
                        }
                    }
                    //buildSwiperSlider(id);
                }
            })
        
        }
        $('.colorSelect, .sizeSelect').on('change',function(){
            updateVariantAndAvailability(true);
        });
        updateVariantAndAvailability(false);
        
        if($('.accordion-title').length > 0 ){
            $('.accordion-title').on('click',function(){
                $(this).parents('.accordion-component').find('.accordion-content').slideToggle();
                $(this).toggleClass('closed');
            })
        }


        $(".product_atc").on("click", function (e) {
            e.preventDefault();
            var formData = $('.right-col form').serialize();
            // console.log(formData);
            $.ajax({
                type: "POST",
                url: "/cart/add.js",
                dataType: "json",
                data: formData,
                success: function (data) {
                    openCart(true);
                    rendering();
                },
                error: function (err) {
                    console.log(err);
                },
            });
        });
    });










});


